import { render, staticRenderFns } from "./BaseImageCropper.vue?vue&type=template&id=0bb7abe2&"
import script from "./BaseImageCropper.vue?vue&type=script&lang=ts&"
export * from "./BaseImageCropper.vue?vue&type=script&lang=ts&"
import style0 from "./BaseImageCropper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports